import React from 'react';

import I18n from '../../../lib/i18n';
import ListImage from './ListImage';
import NewsText from './NewsText';

interface IProps {
  listImage: string;
  text: string;
  movie: number;
}

const NewsListItemOnChannel = (props: IProps) => {
  const { listImage, text, movie } = props;
  return (
    <div>
      <h4>{I18n.t('messages.preview.news_list_item_on_channel')}</h4>
      <div className="news-list-item-on-channel list-image-preview">
        <ListImage listImage={listImage} movie={movie} />
        <NewsText className="news-list-item-on-channel-text" text={text}/>
      </div>
    </div>
  );
};

export default NewsListItemOnChannel;